module.exports = __webpack_public_path__ + "media/images/payments/paybox-dark-4dc93134776daeea60d0ba3266d9c013.svg";